const menuAccess = [{
  key: 'requests',
  label: 'Requests',
  icon_text: 'room_service',
  location: '/access/requests',
  permission: 'service_requests.list',
  component: 'requests/Requests',
  topBar: 'requests/RequestsTopBar',
  path: 'requests',
  menuSection: '/access/requests.*',
  helpUrl: 'https://support.intelity.com',
}, {
  key: 'requests.detail',
  label: 'Service Request Detail',
  location: '/access/requests/:id/:info',
  permission: 'service_requests.read',
  component: 'requests/RequestDetail',
  path: 'requests/:id/:info',
  inactive: true,
}, {
  key: 'requests.edit',
  label: 'Edit Service Request',
  location: '/access/requests/:id/edit',
  permission: 'service_requests.update',
  // component: 'RequestEdit',
  component: 'no-match/NoMatch',
  path: 'requests/:id/edit',
  inactive: true,
}, {
  key: 'requests.create',
  label: 'Create Service Request',
  location: '/access/requests/create',
  permission: 'service_requests.create',
  // component: 'RequestCreate',
  component: 'no-match/NoMatch',
  path: 'requests/create',
  inactive: true,
}, {
  key: 'workorders',
  label: 'Work Orders',
  icon_text: 'build',
  location: '/access/workorders',
  permission: 'work_orders.list',
  component: 'workorders/Workorders',
  topBar: 'workorders/WorkordersTopBar',
  path: 'workorders',
  menuSection: '/access/workorders.*',
  helpUrl: 'https://support.intelity.com',
}, {
  key: 'workorders.create',
  label: 'Create Work Order',
  location: '/access/workorders/create',
  permission: 'work_orders.create',
  component: 'workorders/WorkorderCreate',
  path: 'workorders/create',
  inactive: true,
}, {
  key: 'workorders.edit',
  label: 'Edit Work Order',
  location: '/access/workorders/:id/edit',
  permission: 'work_orders.update',
  component: 'workorders/WorkorderEdit',
  path: 'workorders/:id/edit',
  inactive: true,
}, {
  key: 'workorders.detail',
  label: 'Work Order Detail',
  location: '/access/workorders/:id/:info',
  permission: 'work_orders.read',
  component: 'workorders/WorkorderDetail',
  path: 'workorders/:id/:info',
  inactive: true,
}, {
  key: 'rooms',
  label: 'Rooms',
  icon_text: 'vpn_key',
  location: '/access/rooms',
  path: 'rooms',
  component: 'rooms/Rooms',
  topBar: 'rooms/RoomsTopBar',
  permission: 'locations.list',
  menuSection: '/access/rooms.*',
  helpUrl: 'https://support.intelity.com',
}, {
  key: 'settings',
  label: 'Settings',
  icon_text: 'settings',
  divider: true,
  location: '/access/settings',
  permission: 'user_affiliate.read',
  path: 'settings',
  component: 'settings/Settings',
  menuSection: '/access/settings.*',
}, {
  key: 'rooms.detail',
  label: 'Room Detail',
  location: '/access/rooms/:id/:info',
  permission: 'locations.read',
  component: 'rooms/RoomDetail',
  path: 'rooms/:id/:info',
  inactive: true,
}, {
  key: 'help',
  inactive: true,
  helpUrl: 'https://support.intelity.com',
}];

export default menuAccess;



// WEBPACK FOOTER //
// ./src/config/menu/access.js